/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import Backbone from 'backbone';

var AdHocPropertiesModel = Backbone.Model.extend({
    defaults: {
        showTitle: true,
        loadingOverlay: true,
        autoresize: true,
        designerMode: false,
        _drilldown: null
    }
});
export default AdHocPropertiesModel;
